import { BaseComponent } from '../../base-component';

export class SustainabilityDetailsSheetComponent extends BaseComponent {
    public rootSelector = '.js_pdp_sustainability-details-sheet';

    public async onHtmlLoaded(): Promise<void> {}
}
